<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" class="pa-2">
        <v-flex xs12>
          <div class="text-center" v-if="lmAction === 'view' && lAction === 'view'">
            <v-alert tile color="info" class="white--text body-2 mb-2">
              {{ 'Minimum charge per visit is ₹' + lMin.min + ' which will be waived off if bill amount is more than ₹ ' + lMin.waiver_limit }}
              <v-btn text class="text-md-right" v-if="lAction === 'view' && lmAction === 'view'" @click="loadMinChargeConfig()">Change</v-btn>
            </v-alert>
          </div>
        </v-flex>
        <v-layout wrap>
          <v-flex xs12 sm4 v-for="(serId, n) in serviceList" :key="n">
            <v-card v-if="lAction === 'view' && lmAction === 'view'">
              <v-card-title class="pa-2 title primary--text grey lighten-4">
                <span>{{ servicePriceDet.find(rec => rec.service_id === serId.service_id).service_name + ' (' + servicePriceDet.filter(rec => rec.service_id === serId.service_id).length + ')' }}</span>
              </v-card-title>
              <v-card-text class="pa-0">
                <v-layout>
                  <v-flex xs12>
                    <v-data-table
                    :headers="serviceHeader"
                    :items="servicePriceDet.filter(rec => rec.service_id === serId.service_id)"
                    hide-default-footer
                    disable-pagination
                    :mobile-breakpoint="0">
                    <template slot="item" slot-scope="props">
                      <tr @click="prepareEditPrice(props.item)">
                        <td>{{ props.item.uom }}</td>
                        <td>{{ props.item.price }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view' && lmAction === 'view'"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
      <v-layout row wrap>
        <v-flex xs12 sm6 mx-auto class="pb-0">
          <v-form ref="dForm" @submit.prevent="saveChanges(lAction)">
            <v-card flat>
              <v-card-title class="title pa-3">
                {{ lAction === 'create' ? 'Create Price Configuration' : 'Update Price (' + lPrice.service_pair.service_name  + ')' }}
              </v-card-title>
              <v-card-text>
                <v-layout row wrap>
                  <v-combobox
                  v-model="lPrice.service_pair"
                  label="Service Name"
                  :items="masterServiceList"
                  item-text="service_name"
                  item-value="service_id"
                  :rules="[rules.required]"
                  :disabled="lPrice.is_enable"
                  persistent-hint
                  ></v-combobox>
                  <v-flex xs12>
                    <v-text-field
                    v-model="lPrice.uom"
                    label="Job"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="50"
                    :disabled="lPrice.is_enable"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                    v-model="lPrice.price"
                    label="Price (₹)"
                    :rules="[rules.required]"
                    hide-details
                    type="number"
                    maxlength="11"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-btn v-if="lAction === 'update'" @click="deletePrice(lPrice)">delete</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click.stop="cancelChanges">Cancel</v-btn>
                <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="lmAction === 'update'" class="pa-0" fluid full-height>
      <v-layout row wrap>
        <v-flex xs12 sm6 mx-auto class="pb-0">
          <v-form ref="dForm" @submit.prevent="saveMinConfig">
            <v-card flat>
              <v-card-title class="title pa-3">
                {{'Minimum Charge Configuration'}}
              </v-card-title>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                    v-model="lMin.min"
                    label="Minimum Charge Per Visit (₹)"
                    hide-details
                    type="number"
                    maxlength="11"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                    v-model="lMin.waiver_limit"
                    label="Waiver Limit (₹)"
                    hide-details
                    type="number"
                    maxlength="11"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.stop="cancelChanges">Cancel</v-btn>
                <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- snack bar for reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar"
    :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
  </v-snackbar>
</v-col>
</v-row>
</v-container>
</template>


<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
export default {
  data () {
    return {
      lAction: '',
      lmAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      servicePriceDet: [],
      serviceHeader: [
        { text: 'Job', value: 'uom' },
        { text: 'Price (₹)', value: 'price' }
      ],
      serviceList: [],
      masterServiceList: [],
      lPrice: {},
      lMin: ''
    }
  },
  created () {
    this.loadServicesPrice()
    this.loadserviceList()
    this.loadMinChargeConfig()
    this.lAction = 'view'
    this.lmAction = 'view'
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadServicesPrice () {
      this.axios.get(config.API_URL + '/getServicesPrice/')
      .then(response => {
        this.servicePriceDet = response.data
      })
      .catch(err => {
        this.msg(err)
      })
    },
    loadserviceList () {
      this.axios.get(config.API_URL + '/getServicesList/')
      .then(response => {
        this.serviceList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreate () {
      this.lPrice = {
        service_pair: '',
        price: '',
        uom: ''
      }
      this.lAction = 'create'
      this.loadMasterServiceList()
      this.lPrice.is_enable = false
    },
    prepareEditPrice (curPrice) {
      this.lPrice = Object.assign({}, curPrice)
      this.lPrice.service_pair = {service_id: this.lPrice.service_id, service_name: this.lPrice.service_name}
      this.lAction = 'update'
      this.lPrice.is_enable = true
    },
    loadMasterServiceList () {
      // available services for this vendor
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getSubServicesByVendorId/', qry)
      .then(response => {
        this.masterServiceList = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    saveChanges (action) {
      // validate and save Changes
      if (this.$refs.dForm.validate()) {
        this.beingSaved = true
        this.lPrice.service_id = this.lPrice.service_pair.service_id
        this.lPrice.service_name = this.lPrice.service_pair.service_name
        this.axios.post(config.API_URL + '/price/' + action, this.lPrice)
        .then(response => {
          if (action === 'create') {
            this.servicePriceDet.push(this.lPrice)
          } else {
            var idx = this.servicePriceDet.findIndex(obj => obj.service_id === this.lPrice.service_pair.service_id && obj.uom === this.lPrice.uom)
            Object.assign(this.servicePriceDet[idx], this.lPrice)
          }
          this.lAction = 'view'
          this.loadserviceList()
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    deletePrice (curPrice) {
      if (!confirm('Sure, you want to delete pricing with name ' + '(' + curPrice.service_pair.service_name + '[' + curPrice.uom + ']' + ')' + '?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/price/delete', curPrice)
      .then(response => {
        var idx = this.servicePriceDet.findIndex(obj => obj.service_id === curPrice.service_pair.service_id && obj.uom === curPrice.uom)
        this.servicePriceDet.splice(idx, 1)
        this.loadserviceList()
        this.beingSaved = false
        this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    cancelChanges () {
      this.lAction ='view'
      this.lmAction ='view'
    },
    loadMinChargeConfig () {
      this.lmAction = 'update'
      this.axios.get(config.API_URL + '/getMinimumChargeConfig/')
      .then(response => {
        this.lMin = response.data[0]
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    saveMinConfig () {
      // validate and save Changes
      if (this.$refs.dForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/minPrice/update', this.lMin)
        .then(response => {
          this.msg('Saved successfully', 1)
          this.loadMinChargeConfig()
          this.lmAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    }
  }
}
</script>
